import { currencyOverrides } from './currency-overrides';
import { CurrencyOverridesPosition } from '../../../shared/types/integrations/locale/currency/currency-overrides.type';
import { FormComponent } from '../../../components/cheerfypay/form/form.component';

export class Currency {
    private static convertHtmlCurrency() {
        const elements = $<HTMLElement>('[data-convert-currency]')
            .toArray();
        const currency = FormComponent.getCurrency();

        if (!currency) {
            return;
        }

        for (const element of elements) {
            const {
                convertCurrency,
                isCents,
                sum,
            } = element.dataset;

            let amount: number = Number(convertCurrency);
            const sumAmount = Number(sum);

            if (Number.isNaN(amount)) {
                continue;
            }

            if (!Number.isNaN(sumAmount)) {
                amount += sumAmount;
            }

            if (isCents) {
                amount /= 100;
            }

            element.innerHTML = Currency.toLocaleCurrency(amount, currency);
        }
    }

    private static insertHTMLCurrency() {
        const elements = $<HTMLElement>('[data-currency]')
            .toArray();
        const currency = FormComponent.getCurrency();

        for (const element of elements) {
            element.innerHTML = Currency.toLocaleCurrency(0, currency)
                .replace(/[\d., ]/g, '')
                .trim();
        }
    }

    public static parseHtmlCurrencies() {
        Currency.convertHtmlCurrency();
        Currency.insertHTMLCurrency();
    }

    public static toLocaleCurrency(amount: number, currency: string): string {
        const parts = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            currencyDisplay: 'symbol',
        }).formatToParts(amount);

        const currencyIdx = parts.findIndex((c) => c.type === 'currency');

        if (currencyIdx === -1) {
            return Currency.numberFormatPartsToString(parts);
        }

        const currencyOverride = currencyOverrides[parts[currencyIdx].value];

        if (currencyOverride === undefined) {
            return Currency.numberFormatPartsToString(parts);
        }

        const {
            position,
            overrides,
        } = currencyOverride;

        parts[currencyIdx] = Currency.getNumberFormatPartOverride(parts[currencyIdx], overrides);

        if (position === undefined) {
            return Currency.numberFormatPartsToString(parts);
        }

        const positionedNumberFormatArray = Currency
            .getPositionedNumberFormatArray(parts, parts[currencyIdx], position);

        return Currency.numberFormatPartsToString(positionedNumberFormatArray);
    }

    private static numberFormatPartsToString(parts: Intl.NumberFormatPart[]) {
        return parts.map((p) => p.value).join('');
    }

    private static getPositionedNumberFormatArray(
        parts: Intl.NumberFormatPart[],
        currencyPart: Intl.NumberFormatPart,
        position: CurrencyOverridesPosition,
    ): Intl.NumberFormatPart[] {
        const newPartsArray: Intl.NumberFormatPart[] = parts
            .filter((p) => p.type !== 'currency' && p.type !== 'literal');

        newPartsArray[position === 'start' ? 'unshift' : 'push'](currencyPart);

        return newPartsArray;
    }

    private static getNumberFormatPartOverride(
        formatPart: Intl.NumberFormatPart, overrides: string | undefined,
    ): Intl.NumberFormatPart {
        if (overrides === undefined) {
            return formatPart;
        }

        return {
            ...formatPart,
            value: overrides,
        };
    }
}
